import { render, staticRenderFns } from "./DetailsOverview.vue?vue&type=template&id=6cce4620&"
import script from "./DetailsOverview.vue?vue&type=script&lang=js&"
export * from "./DetailsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports